import {
  RECEIVE_CONFIGS,
  RECEIVE_CONFIGS_ERROR
} from '../../actions/Login/consts'

const defaultState = {
  error: undefined,
  clientId: undefined,
  auth0SsoEnabled: undefined,
  auth0Domain: undefined,
  auth0ClientId: undefined,
  auth0Audience: undefined
}

export default function OauthConfigReducer(state = defaultState, action) {
  switch (action.type) {
  case RECEIVE_CONFIGS:
    return { ...state,
      clientId: action.config.client_id,
      auth0SsoEnabled: action.config.auth0_sso_enabled,
      auth0Domain: action.config.auth0_domain,
      auth0ClientId: action.config.auth0_client_id,
      auth0Audience: action.config.auth0_audience,
      error: undefined }
  case RECEIVE_CONFIGS_ERROR:
    return { ...state, error: action.error }
  default:
    return { ...state }
  }
}
